import { useEffect } from 'react';
import { useRouter } from 'next/router';

const LandingRoute = () => {
  const router = useRouter();

  useEffect(() => {
    router.push('/mate');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
export default LandingRoute;
